import React from "react";
import { useAppSelector } from "../redux/hooks/hooks";
// Optional styling to make the example look nicer
import { selectCpmUser } from "../redux/feature/settings/configurations-slice";

const Home: React.FunctionComponent = () => {
  const cpmUser = useAppSelector(selectCpmUser);

  return (
    <>
      <div>
        <h1>Welcome!</h1>
        <h3>{cpmUser?.descriptionName ?? ""}</h3>
      </div>
    </>
  );
};

export default Home;
